import { render } from "./AlertIcon.vue?vue&type=template&id=10cff84d&scoped=true"
const script = {}

import "./AlertIcon.vue?vue&type=style&index=0&id=10cff84d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10cff84d"],['__file',"src/components/elements/AlertIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10cff84d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10cff84d', __exports__)) {
    api.reload('10cff84d', __exports__)
  }
  
  module.hot.accept("./AlertIcon.vue?vue&type=template&id=10cff84d&scoped=true", () => {
    api.rerender('10cff84d', render)
  })

}


export default __exports__